import styled from 'styled-components'

export const ButtonSliderContainer = styled.div`
width: 100%;
height: auto;

position: absolute;
bottom: 100px;
left: 0;
z-index: 1000;

display: flex;
align-items: center;
justify-content: center;
`